import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { environment } from '../../shared/config/app-config';
import { UserService } from '../../shared';
import { Puser, SWF, User } from '../../shared/models';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'activityboard.component.html',
  styleUrls: ['./style.component.css']
})
export class ActivityBoardComponent implements OnInit {
  success: MatDialogRef<SucesstempComponent>;
  oneAtATime: boolean = true;
  PUser: Puser;
  SWF: SWF;
  swfid: any;
  public mmm: number = 1;
  public data: Object;
  modalRef: BsModalRef;
  activityboard: any
  surveyform: any;
  apiurl: any = environment.api_url;
  documenturl: string = environment.documenturl;
  actbody: any;
  resp: any;
  @ViewChild('videoPlayer') videoplayer: any;
  episodelist: any;
  excludeBundle: boolean;
  CurrentUser: User;
  open: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private userService: UserService,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(userService.defaultLang); 
  }
  log(event: boolean, i, item) {
    this.activityboard[i].open = event;
    window.localStorage.setItem('currentStageName', item.episodeName);
    //////console.log(this.activityboard[i].open);
  };

  video(template: TemplateRef<any>, video) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.actbody = video;
  }
  StageName: any
  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )
    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        //////console.log(this.activityboard);
        this.PUser = puserData;
        if (this.resp.stages) {
          this.resp.stages.forEach((element, i) => {
            if (element.stageId == this.resp.currentStageId) {
              this.StageName = element.stageName;
              this.open = i
            }
          });

        }
        //////console.log(this.PUser);    
      }
    )

    this.swfid = window.localStorage['Puser'];
    this.userService
      .getactivity(window.localStorage['Puser'])
      .subscribe(
        data => {
          this.activityboard = data;
          let index = _.findIndex(this.activityboard, (o: any): any => {
            return o.episodeName == 'Archive Assessment'
          })
          if (index != -1) {
            this.activityboard.splice(index, 1)
          }
          if (window.localStorage['currentStageName']) {
            let index = this.activityboard.findIndex(x => x.episodeName == window.localStorage['currentStageName']);
            this.open = index;
          }
        }
      );
    this.getepisode(this.activityboard);

    //alert(JSON.stringify(this.PUser));


    // Get Exclude Bundle
    this.userService.getExcludeBundle(window.localStorage['Puser']).subscribe(
      data => {
        this.excludeBundle = data.excludeBundle;
        // ////console.log("BundleInfo", this.excludeBundle);
      });


  }

  getepisode(activityboard) {
    return Object.assign({}, activityboard);
    //alert(JSON.stringify(episodelist));
  }
  pauseOrPlay(video) {
    video.pause();
    video.currentTime = 0;

    //////console.log(this.actbody.materialHspPatientMappingId)
    //////console.log(this.actbody.materialType)
    this.userService.updatesurvey(this.actbody.materialHspPatientMappingId, this.actbody.materialType)
      .subscribe(
        data => {
          this.surveyform = data;
          //////console.log(data);
          if (data.updateStatus == "true") {
            this.userService.logAudit("updatereviewstatus", 0).subscribe(data => { })
            this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
            this.success.componentInstance.assessment = 'activity';
            this.success.componentInstance.message = 'completed';
            this.success.componentInstance.fullMessage = this.userService.translateText('patient_portal.assessment.submit_success.message')

            if (window.localStorage['Puser']) {
              this.userService.getusersession()
                .subscribe(
                  data => {
                    if (data)
                      this.userService.setUser(data[0].patientStageWorkflow[0]);
                  },
                  err => this.userService.purgeAuth()
                );
            }
            this.userService
              .getactivity(window.localStorage['Puser'])
              .subscribe(
                data => {
                  this.activityboard = data;
                  let index = _.findIndex(this.activityboard, (o: any): any => {
                    return o.episodeName == 'Archive Assessment'
                  })
                  this.activityboard.splice(index, 1)
                }

              );
          }

        });
  }
  navigateToURL(actbody) {
    let assesDetails = {
      'name': actbody.materialHspPatientMappingId,
      'title': actbody.materialName,
      'materialId': actbody.materialId
    }
    window.localStorage['assesDetails'] = btoa(JSON.stringify(assesDetails))
    this.router.navigateByUrl('/patient/assessment')
  }
  document(actbody) {
    //this.userService.documentURL = actbody.filePath;
    if (actbody.productId == 1000)
      this.router.navigateByUrl('/patient/uploadpage')
    else if (actbody.productId == 1001)
      this.router.navigateByUrl('/patient/profilepage')
    else if (actbody.productId == 1002)
      this.router.navigateByUrl('/patient/helpdeskpage')
    else {
      if (this.excludeBundle)
        actbody.reviewStatus = 'Not Assigned'
      let pdfOption = {
        'type': actbody.fileType ? actbody.fileType : 'pdf',
        'path': actbody.filePath,
        'id': actbody.materialHspPatientMappingId,
        'status': actbody.reviewStatus,
        'materialId': actbody.materialId,
        'patswfid': this.swfid,
        'productID': actbody.productId
      }
      if (pdfOption.type == 'html')
        pdfOption.path = actbody.htmlPath
      window.localStorage['pdfPath'] = btoa(JSON.stringify(pdfOption));
      this.router.navigateByUrl('/patient/preventinginfection')
      // routerLink="/patient/preventinginfection/{{actbody.materialHspPatientMappingId}}/{{actbody.reviewStatus}}/{{actbody.materialId}}/{{this.swfid}}/{{actbody.productId}}/{{actbody.filePath}}"
    }
  }
  getexpiryDueDate(assignDate, dueDate) {
    if (assignDate && dueDate) {
      let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      dueDate = new Date(dueDate);
      assignDate = new Date(assignDate);

      let diffDays = Math.round(Math.abs((dueDate - assignDate) / oneDay));
      if (diffDays == 10000) {
        return true
      } else {
        return false
      }
    }
  }

}
